import React, { useState } from "react";
import { db } from "../firebase";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaFacebookF,
  FaGithub,
  FaLinkedin,
  FaWhatsapp,
} from "react-icons/fa";

function Contact() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    const formData = new FormData(e.currentTarget);
    const data = Object.fromEntries(formData.entries());
    if (!data.Name || !data.Email || !data.Message) {
      setError("Please fill in Name, Email and Message.");
      return;
    }
    try {
      setLoading(true);
      await addDoc(collection(db, "contactLeads"), {
        name: data.Name,
        email: data.Email,
        message: data.Message,
        source: "contact_page",
        createdAt: serverTimestamp(),
      });
      setSuccess("Thanks! Your message was sent successfully.");
      e.currentTarget.reset();
    } catch (e) {
      setError("Could not send your message. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <section id="contact" className="py-16 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800">Contact Me</h2>
          <p className="text-gray-600 mt-2 text-sm">
            I’d love to hear from you. Send a message and I’ll reply shortly.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Contact Form */}
          <form onSubmit={onSubmit} className="bg-gray-50 p-6 rounded-lg shadow-md space-y-5">
            {error && (
              <div className="text-sm font-semibold text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</div>
            )}
            {success && (
              <div className="text-sm font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-md px-3 py-2">{success}</div>
            )}
            <div>
              <label className="block text-sm font-semibold text-gray-700">
                Name
              </label>
              <input
                type="text"
                name="Name"
                placeholder="Your name"
                className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:outline-none"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700">
                Email
              </label>
              <input
                type="email"
                name="Email"
                placeholder="you@example.com"
                className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:outline-none"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700">
                Message
              </label>
              <textarea
                rows="5"
                name="Message"
                placeholder="Type your message..."
                className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:outline-none"
              ></textarea>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="bg-[#211033] text-white px-6 py-2 rounded-lg hover:bg-[#381255] transition-colors duration-300 disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>

          {/* Contact Info & Social */}
          <div className="p-6 rounded-lg shadow-md bg-white flex flex-col gap-6 justify-center">
            {/* Address */}
            <div className="flex items-start gap-4">
              <div className="bg-cyan-100 text-cyan-600 p-3 rounded-full">
                <FaMapMarkerAlt className="text-lg" />
              </div>
              <div>
                <h4 className="text-sm font-bold text-[#211033]">Address</h4>
                <p className="text-sm text-gray-700 mt-1">
                  Rakeen City,
                  <br />
                  Mirpur 13, Dhaka
                </p>
              </div>
            </div>

            {/* Phone */}
            <div className="flex items-start gap-4">
              <div className="bg-cyan-100 text-cyan-600 p-3 rounded-full">
                <FaPhoneAlt className="text-lg" />
              </div>
              <div>
                <h4 className="text-sm font-bold text-[#211033]">Phone</h4>
                <p className="text-sm text-gray-700 mt-1">880-1744-353576</p>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-start gap-4">
              <div className="bg-cyan-100 text-cyan-600 p-3 rounded-full">
                <FaEnvelope className="text-lg" />
              </div>
              <div>
                <h4 className="text-sm font-bold text-[#211033]">Email</h4>
                <p className="text-sm text-gray-700 mt-1">
                  fahimferdous.s@outlook.com
                </p>
              </div>
            </div>

            {/* Social Media */}
            <div className="mt-6">
              <h4 className="text-sm font-bold text-[#211033] mb-3">
                Follow Me
              </h4>
              <div className="flex items-center gap-4">
                <a
                  href="https://fb.com/fahimferdous.shibly"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-100 text-gray-700 hover:text-blue-600 p-3 rounded-full transition"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://linkedin.com/in/fahim-ferdous"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-100 text-gray-700 hover:text-blue-700 p-3 rounded-full transition"
                >
                  <FaLinkedin />
                </a>
                <a
                  href="https://wa.me/8801744353576"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-100 text-gray-700 hover:text-green-600 p-3 rounded-full transition"
                >
                  <FaWhatsapp />
                </a>
                <a
                  href="https://github.com/F-ferdous"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-100 text-gray-700 hover:text-gray-900 p-3 rounded-full transition"
                >
                  <FaGithub />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
